import React from 'react'
import { SellPayoutList } from "./list/page";

export const SellPayoutsPage = (): JSX.Element => {
  return <SellPayoutList></SellPayoutList>
}
